var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolarPower02 = function SvgSolarPower02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "solar-power-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#solar-power-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.127 13.374v-.001ZM20.491 12l-3.364 1.374 2.227 2.87-3.602-.493.494 3.601-2.873-2.227-1.374 3.365-1.374-3.365-2.872 2.227.493-3.6-3.6.492 2.226-2.871-3.364-1.374 3.366-1.373-2.229-2.873 3.601.493-.493-3.6 2.872 2.226 1.374-3.364 1.374 3.364 2.873-2.227-.494 3.601 3.602-.493-2.228 2.873L20.491 12ZM8.323 12a3.677 3.677 0 1 0 7.354 0 3.677 3.677 0 0 0-7.354 0Zm3.061-2.533h1.811l-1.409 2.015h1.66l-2.785 3.051 1.072-2.57-1.179-.053.83-2.443Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "solar-power-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgSolarPower02 as ReactComponent };